import type { RouteRecordRaw } from 'vue-router';

/** 保留历史 Home V3 链接，并将其查询参数完整交给当前 Home。 */
export const legacyHomeV3Redirect: RouteRecordRaw = {
    path: '/home-v3',
    redirect: route => ({
        name: 'home',
        query: route.query,
    }),
};
